import React from "react";
import DragonFlyIllustration from "../../images/illustrations/Dragonfly.inline.svg";

const TextExtraContent = ({
  content,
  extraContentClass = "py-20",
  containerClass = "relative w-full flex justify-center overflow-hidden bg-white ",
  innerContainerClass = "w-11/12 md:w-9/12 mx-auto",
  titleContainerClass = "flex flex-col-reverse md:flex-row gap-6 md:gap-0 justify-between pb-7 items-start md:items-center",
  titleClass = "!font-light",
  contentContainerClass = "overflow-y-auto gvi-scrollbar-thin tab-content",
  contentClass = "pr-3 md:pr-11 text-black-lighter dark:text-gray-generic tab-content_html",
  illustrationBGColorClass = "dark:bg-gray-darker",
  illustrationBGColorAltClass = "dark:bg-gray-darkest",
  scrollContainerClass = "h-108 md:h-80"
}) => {
  const { title, description, showIllustration, longFormat } = content ?? {};

  return (
    <section
      className={`${containerClass} ${
        showIllustration
          ? `${illustrationBGColorClass}`
          : `${illustrationBGColorAltClass}`
      }`}
    >
      {showIllustration && (
        <DragonFlyIllustration className="absolute hidden dark:block -left-[15%] -bottom-[65%]" />
      )}
      <div className={`${innerContainerClass} ${extraContentClass}`}>
        <div className={titleContainerClass}>
          <h1
            className={titleClass}
            dangerouslySetInnerHTML={{ __html: title }}
          />
        </div>
        <div
          className={`${
            longFormat ? scrollContainerClass : ""
          } ${contentContainerClass}`}
        >
          <div
            className={contentClass}
            dangerouslySetInnerHTML={{ __html: description }}
          />
        </div>
      </div>
    </section>
  );
};

export default TextExtraContent;
